// Validazione formale (formato + carattere/cifra di controllo) di codice
// fiscale e partita IVA italiani. Stessi algoritmi del backend
// (app/Rules/CodiceFiscale.php e app/Rules/PartitaIva.php) — usati qui solo
// per dare un feedback immediato in UI, la validazione che conta resta
// quella server-side.

const CF_ODD_MAP: Record<string, number> = {
  '0': 1,
  '1': 0,
  '2': 5,
  '3': 7,
  '4': 9,
  '5': 13,
  '6': 15,
  '7': 17,
  '8': 19,
  '9': 21,
  A: 1,
  B: 0,
  C: 5,
  D: 7,
  E: 9,
  F: 13,
  G: 15,
  H: 17,
  I: 19,
  J: 21,
  K: 2,
  L: 4,
  M: 18,
  N: 20,
  O: 11,
  P: 3,
  Q: 6,
  R: 8,
  S: 12,
  T: 14,
  U: 16,
  V: 10,
  W: 22,
  X: 25,
  Y: 24,
  Z: 23,
};

const CF_EVEN_MAP: Record<string, number> = {
  '0': 0,
  '1': 1,
  '2': 2,
  '3': 3,
  '4': 4,
  '5': 5,
  '6': 6,
  '7': 7,
  '8': 8,
  '9': 9,
  A: 0,
  B: 1,
  C: 2,
  D: 3,
  E: 4,
  F: 5,
  G: 6,
  H: 7,
  I: 8,
  J: 9,
  K: 10,
  L: 11,
  M: 12,
  N: 13,
  O: 14,
  P: 15,
  Q: 16,
  R: 17,
  S: 18,
  T: 19,
  U: 20,
  V: 21,
  W: 22,
  X: 23,
  Y: 24,
  Z: 25,
};

const CF_REGEX =
  /^[A-Z]{6}[0-9LMNPQRSTUV]{2}[A-Z][0-9LMNPQRSTUV]{2}[A-Z][0-9LMNPQRSTUV]{3}[A-Z]$/;

export function validateCodiceFiscale(value: string): boolean {
  const cf = value.trim().toUpperCase();
  if (!CF_REGEX.test(cf)) return false;

  let sum = 0;
  for (let i = 0; i < 15; i++) {
    const map = i % 2 === 0 ? CF_ODD_MAP : CF_EVEN_MAP;
    sum += map[cf[i]] ?? 0;
  }

  const expected = String.fromCharCode(65 + (sum % 26));
  return cf[15] === expected;
}

// Normalizza input "sporco" (prefisso IT copiato da fatture/visure, spazi,
// trattini) nelle 11 cifre nude che l'algoritmo di controllo si aspetta —
// rimuovere ogni carattere non numerico elimina anche il prefisso da solo.
export function sanitizeVatNumber(value: string): string {
  return value.replace(/[^0-9]/g, '').slice(0, 11);
}

export function validatePartitaIva(value: string): boolean {
  const piva = value.trim();
  if (!/^[0-9]{11}$/.test(piva)) return false;

  let sum = 0;
  for (let i = 0; i < 10; i++) {
    let digit = Number(piva[i]);
    if (i % 2 === 1) {
      digit *= 2;
      if (digit > 9) digit -= 9;
    }
    sum += digit;
  }

  const checkDigit = (10 - (sum % 10)) % 10;
  return Number(piva[10]) === checkDigit;
}
